import { size } from 'lodash'

import toFileList from './toFileList'

const handleRemove = ({
  attachments,
  controlName = 'attachments',
  disabled = false,
  event,
  index,
  setValue = () => {},
  inputRef,
}) => {
  if (event) event.stopPropagation()
  if (disabled) return

  let currentFiles = Array.from(attachments) || []
  currentFiles.splice(index, 1)

  const files = toFileList(currentFiles)

  setValue(controlName, size(files) > 0 ? files : null)

  if (inputRef?.current) inputRef.current.value = ''
}

export default handleRemove
